import { motion } from 'motion/react'

import { EmptyState, CheckCircleIcon } from '@buffer-mono/popcorn'

import styles from './DefaultEmptyState.module.css'

const EmptyStateIconMotion = motion.create(EmptyState.Icon)

export const DefaultEmptyState = (): JSX.Element => {
  return (
    <EmptyState
      size="large"
      variant="success"
      role="status"
      aria-label="All comments have been addressed"
    >
      <div className={styles.animationContainer} aria-hidden="true">
        <EmptyStateIconMotion
          className={styles.emptyStateIcon}
          animate={{
            scale: [1, 1.2, 1],
            transition: {
              duration: 1,
            },
            backgroundColor: [
              'var(--color-bg-success-subtle)',
              'var(--global-color-green-300)',
              'var(--color-bg-success-subtle)',
            ],
          }}
        />
        <CheckCircleIcon
          className={styles.checkCircleIcon}
          color="success"
          size="small"
        />
      </div>
      <EmptyState.Heading>
        You&apos;re all caught up! Back to creating 💪
      </EmptyState.Heading>
      <EmptyState.Description>
        We will let you know when new comments appear.
      </EmptyState.Description>
    </EmptyState>
  )
}
